import LaunchIcon from '@mui/icons-material/Launch';
import { IconButton, Link, Stack, Typography } from '@mui/material';
import React, { memo, useMemo, useRef, useState } from 'react';
import { ReactComponent as NotesIcon } from '../../../../../../public/svgs/edit.svg';
import theme from '../../../../../theme';
import { Dashboard } from '../../../../../types/files';
import CommentaryModal from '../../../../modals/tables/dashboards/rows/CommentaryModal';
import useStyles from "../styles";

const edjsParser = require("editorjs-parser").default;
const parser = new edjsParser();

const CommentaryCell: React.FC<{ dashboard: Dashboard }> = ({ dashboard }) => {
    const classes = useStyles();
    const [commentaryModalOpen, setCommentaryModalOpen] = useState<boolean>(false);
    const [fieldHover, setFieldHover] = useState<boolean>(false);
    const latestUpdateRef = useRef<HTMLElement>(null);

    const commentary = useMemo(() =>
        dashboard?.notes?.find(note => note.title === `$['Commentary']`)
    , [dashboard?.notes]);

    const commentaryNote = useMemo(() =>
        new DOMParser().parseFromString(parser.parse({ blocks: (JSON.parse(commentary?.data || '[]') as any[]).slice(1) }), 'text/html')?.body?.textContent?.trim() || ''
    , [commentary?.data]);

    return (<>
        <Stack width="100%" ref={latestUpdateRef} onMouseLeave={() => setFieldHover(false)}>
            {!!commentaryNote.length ? (
                <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%"
                    onMouseEnter={() => setFieldHover(true)}>
                    <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-start">
                        <NotesIcon className={classes.icon} fill="#7bd4d4" />
                        <Typography className={classes.url} sx={{ maxWidth: '20ch !important' }}>
                            {commentaryNote}
                        </Typography>
                    </Stack>
                    {fieldHover && (
                        <Stack direction="row" alignItems="stretch" justifyContent="flex-end">
                            <IconButton disableRipple
                                onClick={() => setCommentaryModalOpen(true)}
                                sx={{ padding: 'unset !important'}}>
                                <LaunchIcon className={classes.icon} sx={{ fill: theme.colors.neutral['500'] }} />
                            </IconButton>
                        </Stack>
                    )}
                </Stack>
            ) : (
                <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-start">
                    <Link fontFamily="Inter" fontSize="0.85rem" fontWeight={500}
                        color={`${theme.colors.neutral['500']} !important`}
                        underline='hover'
                        onClick={() => setCommentaryModalOpen(true)}
                        sx={{ cursor: 'pointer' }}>
                        {'Add commentary...'}
                    </Link>
                </Stack>
            )}
        </Stack>
        {commentaryModalOpen && (
            <CommentaryModal open={commentaryModalOpen}
                dashboard={dashboard}
                newCommentary={!commentaryNote.length}
                anchorElement={latestUpdateRef.current}
                onClose={() => setCommentaryModalOpen(false)} />
        )}
    </>);
}

export default memo(CommentaryCell);
